export default "/_next/static/images/2bf84d8ed9e59cbfe21024b2ac4e5533.svg";